module.exports = __webpack_public_path__ + "static/media/avatar-1.e38a08b5.png";